<template>
	<div class="xs-12">

    <!-- Actions -->
    <div class="flex xs-12 xs-right">
      <j-button 
        v-if="dictionary.hasMultiRows" 
        class="mr2"
        type="secondary"
        size="xsmall" 
        @click="addItem">
          <span class="c5">{{ $t("add_one_row") }}</span>
      </j-button>
      <j-button 
        v-if="dictionary.hasMultiRows" 
        class="mr2"
        type="secondary"
        size="xsmall" 
        @click="()=>{
          addManyFormType = 'multiple'
          $modal.show('add_rows')
        }"
      >
        <span class="c5">{{ $t("add_multiple_rows") }}</span>
      </j-button>
      <j-button 
          v-if="dictionary.hasMultiRows" 
          class="mr2"
          type="secondary"
          size="xsmall" 
          @click="()=>{
            addManyFormType = 'average'
            $modal.show('add_rows')
        }"
        >
          <span class="c5">{{ $t("add_average_rows") }}</span>
      </j-button>
      <j-button 
        v-if="dictionary.hasMultiRows" 
        type="error" 
        size="xsmall" 
        @click="removeAllItems">
          <span class="c5">{{ $t("delete_all_rows") }}</span>
      </j-button>
    </div>

		<!-- Header -->
		<div
      class="flex xs-12 mb2 fs3 c1 fw7 p2 mt2 xs-middle" 
    >
			<div class="xs-2" v-if="dictionary.hasMultiRows">{{ $t("unit") }}</div>
			<div class="xs-4">{{ $t("billed_amount") }}</div>
			<div class="xs-4 pl2">{{ $t("approved_amount") }}</div>
			<div class="xs-2 ta3">{{ $t("count") }}: {{ internalValues ? internalValues.length : 0 }}</div>
		</div>

  

		<!-- List -->
		<div
			class="xs-12 flex wrap mb1 xs-middle bg4 pr2 pl2 pt1 pb1 r2"
			v-for="(item, i) in paginatedInternalValues"
			:key="i"
		>
			<div class="xs-2 fs3 fw7 c6" v-if="dictionary.hasMultiRows">
				{{ $t(dictionary ? dictionary.unit : "") }}
				{{ (currentPage - 1) * itemsPerPage + i + 1 }}
			</div>
			<div class="flex xs-4 pr2">
				<div class="xs-9 pr2">
					<!-- Billed Amount -->
					<core-form-input
						name="billed_amount"
						size="small"
						componentName="j-base-input-number"
						:placeholder="$t('billed_amount')"
						v-model="item.billedAmount"
						@blur="onUpdate"
					/>
				</div>
				<div class="xs-3">
					<!-- Billed Currency -->
					<core-form-input
						name="billed_currency"
						size="small"
						componentName="core-select-currency"
						v-model="item.billedCurrency"
						@input="onUpdate"
					/>
				</div>
			</div>
			<div class="flex xs-4 pl2">
				<div class="xs-9 pr2">
					<!-- Approved Amount -->
					<core-form-input
						name="approved_amount"
						size="small"
						componentName="j-base-input-number"
						:placeholder="$t('approved_amount')"
						v-model="item.approvedAmount"
						@blur="onUpdate"
					/>
				</div>
				<div class="xs-3">
					<!-- Approved Currency -->
					<core-form-input
						name="approved_currency"
						size="small"
						componentName="core-select-currency"
						v-model="item.approvedCurrency"
						@input="onUpdate"
					/>
				</div>
			</div>

      
			<!-- Remove item -->
			<div class="flex xs-2 xs-right xs-middle" v-if="dictionary.hasMultiRows">
				<crm-icon
					name="delete"
					color="cError"
					class="cu2"
					@click.native="removeItem((currentPage - 1) * itemsPerPage + i)"
				/>
			</div>

			<!-- Error message -->
			<div
				class="xs-8 mt1 fs3 cError lh125"
				:class="{ 'xs-offset2': dictionary.hasMultiRows }"
			>{{ item.errorMessage }}</div>
		</div>

		<!-- Too many items error -->
		<div class="xs-12 fs3 cError lh125 mt2 mb2">{{ occurenceErrorMessage }}</div>

		<!-- Pagination -->
		<div class="xs-12 mt4" v-if="dictionary.hasMultiRows">
			<j-pagination
				:amount="internalValues ? internalValues.length : 0"
				:perPage="itemsPerPage"
				:activePage="currentPage"
				@click="currentPage = $event"
			/>
		</div>

    <!-- Modal for adding rows -->
    <core-modal 
      name="add_rows" 
      :headline="addManyFormType === 'multiple' 
        ? $t('add_multiple_rows') 
        : $t('add_average_rows')"
    >
      <template-table-add-row
				:formType="addManyFormType"
				@addMany="addManyItems"
			/> 
    </core-modal>
    <!-- Modal for adding rows -->
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CoreModal from "@/modules/core/components/CoreModal"
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"
import TemplateTableAddRow from "./TemplateTableAddRow"
import JPagination from "@/components/JPagination"

export default {
	components: {
    CoreFormInput,
    CoreModal,
		CrmIcon,
		JButton,
		TemplateTableAddRow,
		JPagination
	},
	props: {
		/**
		 * Values that we get from the API claims.benefitClaims.values
		 */
		values: {
			type: Array,
			default: () => []
		},

		/**
		 * Object with definitions for what template to display and what to validate and how
		 * More in dictionary.js file
		 * Eventually this dictionary will be fetched from backend
		 */
		dictionary: {
			type: Object,
			default: () => ({
				unit: null
			})
		},

		/**
		 * Benefit object we get from API that has a few more fields  added - remainingValue and remainingScalarValue
		 */
		benefit: {
			type: Object,
			default: () => ({})
    }

	},
	data() {
		return {
			/**
			 * We have internal state of the form
			 * On any change of the form we emit event up where API is called to do the update
			 * After API call, we do not refresh internal state of this form as we are assuming update was successful
			 * In case of update error, we refresh internal state by force rendering this component so that user notices something is wrong
			 * These mechanics should assure fast and smooth editing experience
			 */
			internalValues: this.values
				? JSON.parse(JSON.stringify(this.values))
				: [], // immutable

			// Pagination
			currentPage: 1,
			itemsPerPage: 10,

			// Add many expanded
			isAddManyExpanded: false,

			/**
			 * "multiple" - Form will ask for number of rows to multiple. `billedAmount` and `approvedAmount` inputs will be the same for each row
			 * "average" - Form will ask for total `billedAmount` and `approvedAmount` for this benefit and divide by number of days
			 */
			addManyFormType: "multiple"
		}
	},

	computed: {
		/**
		 * Sliced internalValues based on pagination
		 */
		paginatedInternalValues() {
			const start = (this.currentPage - 1) * this.itemsPerPage
			const end = start + this.itemsPerPage
			return this.internalValues.slice(start, end)
		},

		/**
		 * Calculate number of pages
		 */
		numberOfPages() {
			return Math.ceil(
				this.internalValues.length / this.itemsPerPage
			)
		},

		// Part of validation, if there is dictionary.occurrenceLimit check number of items in the array
		// and if it's more show error
		occurenceErrorMessage() {
			if (this.dictionary.occurrenceLimit) {
				const key = this.dictionary.occurrenceLimit
				const value = this.benefit?.remainingScalarValue?.objectValue.find(
					item => item.key === key
				)?.value?.numberValue

				if (!value) return ""
				if (value < 0) return this.getErrorMessage("004")
			}

			return ""
		}
	},

	methods: {
		addItem() {
			const schema = {
				billedAmount: null,
				billedCurrency:
					this.$store.state.settings.preferredCurrency ||
					null,
				approvedAmount: null,
				approvedCurrency:
					this.$store.state.settings.preferredCurrency ||
					null,
				unit: this?.dictionary?.unit || null
			}

			this.internalValues.push(schema)
			this.$emit("updated", this.internalValues)

			// If added item leaked to next page, change page
			if (this.currentPage < this.numberOfPages)
				this.currentPage = this.numberOfPages
		},

		addManyItems({
			howMany,
			billedAmount,
			billedCurrency,
			approvedAmount,
			approvedCurrency
		}) {

      this.$modal.hide("add_rows")

			if (!parseInt(howMany)) return

			if (this.addManyFormType === "multiple") {
				this.internalValues = [
					...this.internalValues,
					...Array.from(new Array(parseInt(howMany))).map(
						item => ({
							billedAmount,
							billedCurrency,
							approvedAmount,
							approvedCurrency,
							unit: this?.dictionary?.unit || null
						})
					)
				]
			}

			if (this.addManyFormType === "average") {
				let approvedAmountAverage = approvedAmount / howMany
				let billedAmountAverage = billedAmount / howMany
				this.internalValues = [
					...Array.from(new Array(parseInt(howMany))).map(
						item => ({
							billedAmount: billedAmountAverage,
							billedCurrency,
							approvedAmount: approvedAmountAverage,
							approvedCurrency,
							unit: this?.dictionary?.unit || null
						})
					)
				]
			}

			this.currentPage = this.numberOfPages // Change page to the last one
			this.$emit("updated", this.internalValues)
		},

		removeItem(index) {
			this.internalValues.splice(index, 1)
			this.$emit("updated", this.internalValues)

			// If deleted item was the last one on the page, change page
			if (this.currentPage > this.numberOfPages)
				this.currentPage = this.numberOfPages
		},

		removeAllItems() {
			this.internalValues = []
			this.currentPage = 0 // Change page to 0 as there is 0 items
			this.$emit("updated", this.internalValues)
		},

		onUpdate() {
			// Emit up to parent where API call is made
			this.$emit("updated", this.internalValues)

			// Run Validations
			this.internalValues = this.validateAll(this.internalValues)
		},

		/**
		 * Will iterate through all passed values and validate it
		 */
		validateAll(values) {
			if (!values) return []
			return values.map(item => ({
				...item,
				errorMessage: this.validate(item)
			}))
		},

		/**
		 * Validation method that is based on dictionary will properly validate Approved Amount
		 * @returns {String} - errorMessage
		 */
		validate({
			billedAmount,
			approvedAmount,
			approvedCurrency,
			billedCurrency
		}) {
			/**
			 * @desc 1: If dictionary.coInsurance while the same currency
			 */
			if (this.dictionary.coInsurance) {
				const key = this.dictionary.coInsurance
				const coInsurance = this.benefit?.remainingScalarValue?.objectValue.find(
					item => item.key === key
				)?.value?.numberValue

				if (
					approvedCurrency === billedCurrency &&
					approvedAmount >
						billedAmount - billedAmount * coInsurance
				)
					return this.getErrorMessage(
						"005",
						(
							billedAmount -
							billedAmount * coInsurance
						).toFixed(2)
					)
			}

			/**
			 * @desc 2: If approvedAmount is greater than billedAmount while the same currency
			 */
			if (
				approvedCurrency === billedCurrency &&
				approvedAmount > billedAmount
			)
				return this.getErrorMessage("002")

			/**
			 * @desc 3: If dictionary.amountLimit
			 */
			if (this.dictionary.amountLimit) {
				const key = this.dictionary.amountLimit
				const amountLimitValue = this.benefit?.remainingScalarValue?.objectValue.find(
					item => item.key === key
				)?.value?.numberValue

				if (!amountLimitValue) return ""
				if (
					approvedCurrency === billedCurrency &&
					amountLimitValue < approvedAmount
				)
					return this.getErrorMessage("003")
			}

			/**
			 * @desc 4: If dictionary.remainingLimit
			 */
			if (this.dictionary.remainingLimit) {
				const key = this.dictionary.remainingLimit
				const remainingLimitValue = this.benefit?.remainingScalarValue?.objectValue.find(
					item => item.key === key
				)?.value?.numberValue

				if (!remainingLimitValue) return ""
				if (
					approvedCurrency === billedCurrency &&
					remainingLimitValue < 0
				)
					return this.getErrorMessage("003")
			}

			return ""
		},

		getErrorMessage(code, param1 = "", param2 = "", param3 = "") {
			// TODO: localize - should come from localization file

			const messages = {
				"001": "There is potential conflict",
				"002": "Approved amount is greater than Billed amount",
				"003":
					"Approved amount is greater than Remaining amount",
				"004": "Too many items",
				"005": `Approved amount is greater than Billed amount when taking into account coinsurance. Allowed Approved amount is: ${param1}`
			}

			return messages[code] ? messages[code] : ""
		}
	},

	mounted() {
		// If it doesn't have multiRows and values are empty, populate it so that we can display the form with at least one row
		if (
			!this.hasMultiRows &&
			(!this.values || this.values?.length === 0)
		) {
			this.internalValues.push({
				billedAmount: null,
				billedCurrency:
					this.$store.state.settings.preferredCurrency ||
					null,
				approvedAmount: null,
				approvedCurrency:
					this.$store.state.settings.preferredCurrency ||
					null,
				unit: this.dictionary.unit
			})
			this.$emit("updated", this.internalValues)
		}
	},

	watch: {
		values: {
			handler() {
				// Run validation on internalValues anytime values changes
				this.internalValues = this.validateAll(
					this.internalValues
				)
			},
			immediate: true,
			deep: true
		}
	}
}
</script>